'use client';

import { XIcon } from 'lucide-react';
import { Button } from '@repo/ux/button';
import { setToLocalStorage } from '@/helpers/localStorage';

import { useCookieContext } from './CookieProvider';
import CookieSettingsModal from './CookieSettingsModal';

export const SHOW_COOKIE_BANNER = 'showCookieBanner';
export const USE_OPTIONAL_COOKIES = 'useOptionalCookies';

export type StoredShowCookieBanner = 'true' | 'false' | null;

function CookieBanner() {
  const {
    showBanner,
    showCookieSettings,
    setCookieSettings,
    setShowCookieSettings,
    setShowBanner,
  } = useCookieContext();

  const handleAcceptCookies = () => {
    setCookieSettings({
      enableOptionalCookies: true,
      enableAnalytics: true,
    });
    setToLocalStorage(SHOW_COOKIE_BANNER, 'false');
    setShowBanner(false);
  };

  const handleRejectCookies = () => {
    setCookieSettings({
      enableOptionalCookies: false,
      enableAnalytics: false,
    });
    setToLocalStorage(SHOW_COOKIE_BANNER, 'false');
    setShowBanner(false);
  };

  const handleShowCookieSettings = () => {
    setShowCookieSettings(true);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <>
      {showCookieSettings ? (
        <CookieSettingsModal
          isOpen={showCookieSettings}
          setIsOpen={setShowCookieSettings}
        />
      ) : null}

      <div className="bg-spkblue-base_color fixed inset-x-0 bottom-0 flex px-6 py-4 print:hidden">
        <div className="flex w-full flex-col items-center md:justify-between md:px-6 gap-2 md:flex-row justify-center">
          <p className="text-sm text-white">
            <span>
              We use cookies and analytics to ensure that we give you the best
              experience on our website.
            </span>
            <a
              className="ml-2 inline text-pink-500 underline"
              href="/privacy/policy/"
              rel="noopener noreferrer"
              target="_blank"
            >
              Privacy Policy
            </a>
          </p>
          <div className="flex flex-row gap-4">
            <Button
              variant="default"
              className="bg-blue-600 text-white hover:cursor-pointer hover:bg-blue-500"
              onClick={handleAcceptCookies}
            >
              Accept all Cookies
            </Button>
            <Button
              className="bg-blue-600 text-white hover:cursor-pointer hover:bg-blue-500"
              onClick={handleShowCookieSettings}
            >
              Set Cookie Preferencesss
            </Button>
          </div>
        </div>

        <Button
          aria-label="Reject cookies"
          variant="ghost"
          size="icon"
          className="absolute right-2 top-2 size-8 bg-transparent hover:cursor-pointer hover:bg-opacity-10"
          onClick={handleRejectCookies}
        >
          <XIcon className="stroke-3 h-4 w-4 text-white" />
        </Button>
      </div>
    </>
  );
}

export default CookieBanner;
